import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './BillingManagement.css'

const BillingManagement = () => {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')

  // Static data for billing users
  const [billingUsers] = useState([
    { id: 1, name: 'Usman', email: 'usman@abc.com', role: 'Owner', business: 'ABC Corp', plan: 'Pro', status: 'Active' },
    { id: 2, name: 'Aashar', email: 'aashar@abc.com', role: 'Trainer', business: 'ABC Corp', plan: 'Pro', status: 'Pending' },
    { id: 3, name: 'Ahmad', email: 'ahmad@abc.com', role: 'Editor', business: 'ABC Corp', plan: 'Pro', status: 'Pending' },
    { id: 4, name: 'Usman', email: 'usman@abc.com', role: 'Viewer', business: 'ABC Corp', plan: 'Pro', status: 'Pending' },
    { id: 5, name: 'Usman', email: 'usman@abc.com', role: 'Editor', business: 'ABC Corp', plan: 'Pro', status: 'Pending' },
    { id: 6, name: 'John Smith', email: 'johnsmith@abc.com', role: 'Viewer', business: 'ABC Corp', plan: 'Pro', status: 'Pending' },
    { id: 7, name: 'Usman', email: 'usman@abc.com', role: 'Editor', business: 'ABC Corp', plan: 'Pro', status: 'Failed' },
    { id: 8, name: 'Usman', email: 'usman@abc.com', role: 'Viewer', business: 'ABC Corp', plan: 'Pro', status: 'Failed' }
  ])

  const filteredUsers = billingUsers.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleViewBilling = (userId) => {
    navigate(`/billing-details/${userId}`)
  }

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'status-badge status-active'
      case 'pending':
        return 'status-badge status-pending'
      case 'failed':
        return 'status-badge status-failed'
      default:
        return 'status-badge'
    }
  }

  return (
    <div className="billing-management-container">
      <div className="billing-management-header">
        <h1 className="page-title">Billing Management</h1>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search user by name or email"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="table-wrapper">
        <table className="billing-table">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Business</th>
              <th>Subscription Plan</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data">
                  No users found
                </td>
              </tr>
            ) : (
              filteredUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    <span className="role-badge">{user.role}</span>
                  </td>
                  <td>{user.business}</td>
                  <td>{user.plan}</td>
                  <td>
                    <span className={getStatusBadgeClass(user.status)}>
                      {user.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="view-billing-btn"
                      onClick={() => handleViewBilling(user.id)}
                    >
                      View Billing
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default BillingManagement









